
import { Component, Mixins } from "vue-property-decorator";
import { default as PageNoEditableMixin } from "./PageNoEditableMixin.vue";

@Component
export default class DocumentPresentableMixin extends Mixins(PageNoEditableMixin) {
}
